import { PhotoIcon, UserCircleIcon } from "@heroicons/react/24/solid";
import { ChevronDownIcon } from "@heroicons/react/16/solid";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  changeUserPassword,
  getUserProfile,
  updateUserProfile,
} from "../../../../slices/userSlice";

export default function ClientSettings() {
  const { userInfo, loading, error } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    firstName: userInfo?.name || "",
    lastName: userInfo?.lastName || "",
    username: userInfo?.username || "",
    email: userInfo?.email || "",
  });

  const [passwordFields, setPasswordFields] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [loading1, setLoading1] = useState(false);
  const [error1, setError1] = useState(null);
  const [selectedImageProfile, setSelectedImageProfile] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    if (!userInfo || !userInfo.email) {
      dispatch(getUserProfile());
    }
  }, [dispatch, userInfo]);

  const userProfileImage =
    userInfo?.profileImage ||
    `https://ui-avatars.com/api/?name=${formData.firstName}+${formData.lastName}&background=random`;

  const handleProfilePicture = (file) => {
    if (file) {
      setSelectedImageProfile(file);
      setImageUrl(URL.createObjectURL(file));
    } else {
      setImageUrl(null);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    const { currentPassword, newPassword, confirmNewPassword } = passwordFields;

    if (newPassword !== confirmNewPassword) {
      alert("Las contraseñas nuevas no coinciden.");
      return;
    }

    try {
      setLoading1(true);
      await dispatch(changeUserPassword({ currentPassword, newPassword }));
      alert("Contraseña cambiada con éxito");
      setPasswordFields({ currentPassword: "", newPassword: "", confirmNewPassword: "" });
    } catch (error) {
      setError1(error.message || "Error al cambiar la contraseña");
    } finally {
      setLoading1(false);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const sendformData = new FormData();
    const data = { ...userInfo };

    let hasChangesValid = false;
    const updatedUser = {};

    if (formData.firstName !== data.name) {
      updatedUser.name = formData.firstName;
      hasChangesValid = true;
    }
    if (formData.lastName !== data.lastName) {
      updatedUser.lastName = formData.lastName;
      hasChangesValid = true;
    }
    if (formData.username !== data.username) {
      updatedUser.username = formData.username;
      hasChangesValid = true;
    }
    if (formData.email !== data.email) {
      updatedUser.email = formData.email;
      hasChangesValid = true;
    }

    if (hasChangesValid) {
      sendformData.append("myUser", JSON.stringify(updatedUser));
    }

    if (selectedImageProfile) {
      sendformData.append("imageProfile", selectedImageProfile);
    }

    if (hasChanges || selectedImageProfile) {
      dispatch(updateUserProfile(sendformData));
      dispatch(getUserProfile())
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => {
      const newFormData = { ...prevData, [name]: value };
      const hasChanges = Object.keys(newFormData).some(
        (key) => newFormData[key] !== userInfo[key]
      );
      setHasChanges(hasChanges);
      return newFormData;
    });
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordFields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
  };

  return (
    <form className="p-5 max-w-4xl bg-background mx-auto" onSubmit={submitHandler}>
      <div className="space-y-12">
        
        <div className="border-b border-gray-200 pb-12">
          <h2 className="text-2xl font-bold text-text">Perfil</h2>
          <p className="mt-2 text-sm text-gray-500">
            Esta información se mostrará públicamente, así que ten cuidado con lo
            que compartes.
          </p>

          <div className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-6">
           
            <div className="col-span-full">
              <label
                htmlFor="photo"
                className="block text-sm font-medium text-gray-700"
              >
                Foto de perfil
              </label>
              <div className="mt-2 flex items-center gap-x-4">
                <img
                  src={imageUrl || userProfileImage}
                  alt="Profile"
                  className="h-24 w-24 rounded-full object-cover shadow-lg"
                />
                <input
                  type="file"
                  id="photo"
                  name="photo"
                  className="sr-only"
                  onChange={(e) => handleProfilePicture(e.target.files[0])}
                />
                <label
                  htmlFor="photo"
                  className="rounded-md bg-background px-4 py-2 text-sm font-medium text-subtitle shadow-sm ring-1 ring-border hover:bg-gray-50 cursor-pointer transition duration-200"
                >
                  Cambiar
                </label>
              </div>
            </div>
          </div>
        </div>

        
        <div className="border-b border-gray-200 pb-12">
          <h2 className="text-2xl font-bold text-text">
            Información Personal
          </h2>
          <p className="mt-2 text-sm text-gray-500">
            Usa una dirección permanente donde puedas recibir correo.
          </p>

          <div className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-6">
           
            <div className="sm:col-span-3">
              <label
                htmlFor="firstName"
                className="block text-sm font-medium text-gray-700"
              >
                Nombre
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="block w-full rounded-lg border border-border bg-background px-4 py-2 text-sm text-text shadow-sm focus:border-indigo-500 focus:ring-indigo-500 transition duration-200"
                />
              </div>
            </div>

            
            <div className="sm:col-span-3">
              <label
                htmlFor="lastName"
                className="block text-sm font-medium text-gray-700"
              >
                Apellido
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="block w-full rounded-lg border bg-background text-text border-border px-4 py-2 text-sm text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 transition duration-200"
                />
              </div>
            </div>

            
            <div className="sm:col-span-4">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Correo electrónico
              </label>
              <div className="mt-2">
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="block w-full rounded-lg border bg-background text-text border-border px-4 py-2 text-sm text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 transition duration-200"
                />
              </div>
            </div>
          </div>
        </div>

        
        <div className="border-b border-gray-200 pb-12">
          <h2 className="text-2xl font-bold text-text">
            Cambiar Contraseña
          </h2>
          <p className="mt-2 text-sm text-gray-500">
            Asegúrate de que tu nueva contraseña sea segura y no la compartas
            con nadie.
          </p>

          <form onSubmit={handleChangePassword} className="mt-8 grid grid-cols-1 gap-8 sm:grid-cols-6">
            
            <div className="sm:col-span-4">
              <label
                htmlFor="currentPassword"
                className="block text-sm font-medium text-gray-700"
              >
                Contraseña Actual
              </label>
              <div className="mt-2">
                <input
                  type="password"
                  id="currentPassword"
                  name="currentPassword"
                  value={passwordFields.currentPassword}
                  onChange={handlePasswordChange}
                  className="block w-full rounded-lg border bg-background text-text border-border px-4 py-2 text-sm text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 transition duration-200"
                />
              </div>
            </div>

           
            <div className="sm:col-span-4">
              <label
                htmlFor="newPassword"
                className="block text-sm font-medium text-gray-700"
              >
                Nueva Contraseña
              </label>
              <div className="mt-2">
                <input
                  type="password"
                  id="newPassword"
                  name="newPassword"
                  value={passwordFields.newPassword}
                  onChange={handlePasswordChange}
                  className="block w-full rounded-lg border bg-background text-text border-border px-4 py-2 text-sm text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 transition duration-200"
                />
              </div>
            </div>

            <div className="sm:col-span-4">
              <label
                htmlFor="confirmNewPassword"
                className="block text-sm font-medium text-gray-700"
              >
                Confirmar Nueva Contraseña
              </label>
              <div className="mt-2">
                <input
                  type="password"
                  id="confirmNewPassword"
                  name="confirmNewPassword"
                  value={passwordFields.confirmNewPassword}
                  onChange={handlePasswordChange}
                  className="block w-full rounded-lg border bg-background text-text border-border px-4 py-2 text-sm text-gray-900 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 transition duration-200"
                />
              </div>
            </div>

            <div className="sm:col-span-4">
              <button
                type="submit"
                className="rounded-lg bg-indigo-600 px-6 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition duration-200"
              >
                Cambiar Contraseña
              </button>
            </div>
          </form>
        </div>
      </div>

    
      <div className="mt-8 flex justify-end gap-x-4">
        <button
          type="button"
          className="rounded-lg bg-white px-6 py-2 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-gray-300 hover:bg-gray-50 transition duration-200"
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="rounded-lg bg-indigo-600 px-6 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition duration-200"
        >
          Guardar
        </button>
      </div>
    </form>
  );
}